import * as React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import strftime from 'strftime';
import {Button, TYPES} from './../shared/button'

class VerificationData extends React.Component {

  constructor() {
    super()

    this.state = {
      unverifiedVisits: []
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.unverifiedVisits !== this.props.unverifiedVisits) {
      this.setState({unverifiedVisits: this.props.unverifiedVisits})
      this.props.getVerificationTotal()
    }
  }

  claimVisit = (visit, index) => {
    const user = this.props.auth.user.id
    let headers = { "Content-Type": "application/json", "Authorization":`JWT ${this.props.auth.token}` }
    let payload = { verifier: user }
    axios.post(`/api/verifications/${visit}/claim/`, payload, {headers}).then(results => {
      let unverifiedVisits = this.state.unverifiedVisits
      unverifiedVisits[index] = results.data
      this.setState({unverifiedVisits: unverifiedVisits})
    }).catch(error => {
      alert('Error')
    })
  }

  displayUserNameOrClaimButton = (visit, index) => {
    if(visit.verifier) {
      return visit.verifier.first_name
    } else {
      return(
        <Button
          text='Claim Visit'
          type='recordingsAction'
          buttonType={TYPES.DEFAULT}
          onClick={() => this.claimVisit(visit.id, index)}
        />
      )
    }
  }

  displayVerificationOrVideoUnavailableButton = (visit, index) => {
    const triggerVideoId = visit.recordings[0].id
    if(triggerVideoId === null) {
      return (
        <Link to={`/verification/${visit.id}/recordings/${visit.recordings[0].id}`}>
          <Button
            text='Video Unavailable'
            type='recordingsActionDisabled'
            buttonType={TYPES.DEFAULT}
            disabled={true}
          />
        </Link>
      )
    } else {
      return (
        <Link to={`/verification/${visit.id}/recordings/${visit.recordings[0].id}`}>
          <Button
            text='Verify Visit'
            type='recordingsAction'
            buttonType={TYPES.DEFAULT}
            disabled={false}
            onClick={() => this.claimVisit(visit.id, index)}
          />
        </Link>
      )
    }
  }


  render () {
    const {unverifiedVisits} = this.state
    return (
      <div>
        <table className='recordings-table'>
          <thead>
            <tr>
              <th className='recordings-table-header'>License Plate</th>
              <th className='recordings-table-header'>Trigger At</th>
              <th className='recordings-table-header'>Bay</th>
              <th className='recordings-table-header'>Location</th>
              <th className='recordings-table-header'>Action</th>
            </tr>
          </thead>
          <tbody>
            {unverifiedVisits &&
              unverifiedVisits.map((visit, index)=> {
                return(
                  <tr className='recordings-row' key={"unverifiedVisit" + index}>
                    <td className='recording-indent'>{visit.license_plate}</td>
                    <td className='recording-indent'>{strftime('%B %d, %Y %I:%M %p', new Date(visit.triggered_at))}</td>
                    <td className='recording-indent' align='center'>{visit.bay_number}</td>
                    <td className='recording-indent' align='center'>{visit.location}</td>
                    <td className='recording-indent' align='center'>
                      {this.displayVerificationOrVideoUnavailableButton(visit, index)}
                    </td>
                  </tr>
                )
            })}
          </tbody>
        </table>
        <p id='verification-total'>{this.state.unverifiedVisits.length} of {this.props.totalVerifications}</p>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(VerificationData)



// WEBPACK FOOTER //
// ./src/components/verification/verificationData.js